<page-grid [gridConfig]="paymentsReceivedGrid" (gridClickColumn)="openDialog($event)" (gridEvent)="openCreatePaymentDialog();" />